// react
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES, buildUrl } from 'router';

// hooks
import { useCareProfile } from 'hooks';
import { useGoBack } from 'hooks/useGoBack';

// components
import { FormCompletePage } from '@karehero/llama/pwa/pages/FormCompletePage/FormCompletePage';
import { CareProfileCategoryID } from '@karehero/models';

/**
 * CareProfileComplete is the dashboard page.
 */
export const CareProfileComplete = () => {
  // hooks
  const navigate = useNavigate();
  const goBack = useGoBack();
  const { category, toLastFormPage, handleSubmit } = useCareProfile({
    categoryID: CareProfileCategoryID.CareAssessment,
  });

  const handleNext = useCallback(() => {
    handleSubmit();
    navigate(buildUrl(ROUTES.BOOK_CALL, { category: 'find-care' }));
  }, [handleSubmit, navigate]);

  return (
    <FormCompletePage
      onBack={goBack}
      title='Care Assessment'
      isComplete={category?.progress?.isComplete || false}
      items={[
        {
          icon: 'check-circle',
          text: 'Review your Care Assessment answers to ensure all the needs captured are correct',
        },
        {
          icon: 'user',
          text: 'Once submitted you can chat to your Care Expert regarding your Care Assessment',
        },
        {
          icon: 'file-contract',
          text: 'Your Care Expert will now provide a care search shortlist tailored by your Care Assessment',
        },
      ]}
      onSubmit={handleNext}
      onPrevious={() =>
        navigate(toLastFormPage, { replace: true, state: { back: true } })
      }
      isSubmitDisabled={!category?.progress?.isComplete}
    />
  );
};

export default CareProfileComplete;
